const { api_base_url, chat_base_url, chat_protocol } = window['runConfig'];

export const CONFIG = {
	api_base_url,
	chat_base_url,
	chat_protocol,
};
